import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Modal, ModalHeader, Button, ModalBody, ModalFooter, FormGroup, Label, Input, Form, Table } from 'reactstrap';
import Select from 'react-select';
import axios from 'axios';
import uuid from 'react-uuid';
import toast, { Toaster } from 'react-hot-toast';
import "../ExternalOrganisation/ExternalOrganisation.css";
import Validate from '../Validate/Validate';
import { FaChevronLeft, FaUpload, FaTrash, FaPlus } from 'react-icons/fa';
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";

const CreateExternalOrganisation = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [externalOrganisationList, setExternalOrganisationList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [id, setId] = useState(0); const [name, setName] = useState(''); const [organisationType, setOrganisationType] = useState(0);
    const [supplyType, setSupplyType] = useState(0); const [regionalCouncils, setRegionalCouncils] = useState([]);
    const [description, setDescription] = useState(''); const [regionalCouncilId, setRegionalCouncilId] = useState(0);
    const [isLicensedforEnterpriseDashboard, setIsLicensedforEnterpriseDashboard] = useState(false);
    const [externalLink, setExternalLink] = useState('');
    const [logoFile, setLogoFile] = useState('');
    const [logoImagePreviewUrl, setLogoImagePreviewUrl] = useState('');
    const [logoName, setLogoName] = useState('');
    const [logoPhysicalFilename, setLogoPhysicalFilename] = useState('');
    const [logoPhysicalFilepath, setLogoPhysicalFilepath] = useState('');
    const [imageFile, setImageFile] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [imageName, setImageName] = useState('');
    const [imagePhysicalFilename, setImagePhysicalFilename] = useState('');
    const [imagePhysicalFilepath, setImagePhysicalFilepath] = useState('');
    const [showCatchmentItems, setShowCatchmentItems] = useState(false);
    const [catchmentOverview, setCatchmentOverview] = useState('');
    const [culturalValues, setCulturalValues] = useState('');
    const [significantSpecies, setSignificantSpecies] = useState('');
    const [priorityContaminantList, setPriorityContaminantList] = useState([]);
    const [priorityContaminantListSelectedValues, setPriorityContaminantListSelectedValues] = useState([]);
    const [priorityContaminantSelectedValues, setPriorityContaminantSelectedValues] = useState('');
    const [showSupplyCompanyItems, setShowSupplyCompanyItems] = useState(false);
    const [editPopupTitle, setEditPopupTitle] = useState('Add External Organisation');
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const [documentDownloadUrl, setDocumentDownloadUrl] = useState('');
    const [uploadDocumentName, setUploadDocumentName] = useState('');
    const [formDocumentErrors, setFormDocumentErrors] = useState({});
    const [uploadDocumentPhysicalFilename, setUploadDocumentPhysicalFilename] = useState('');
    const [uploadDocumentPhysicalFilepath, setUploadDocumentPhysicalFilepath] = useState('');
    let inputDocumentFile = '';
    let inputLogoFile = '';
    let inputImageFile = ''; const [externalOrganisationLinkRows, setExternalOrganisationLinkRows] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams(); const [idValue, setIdValue] = useState(0); const [organisationTypeValue, setOrganisationTypeValue] = useState(0);
    const [nameValue, setNameValue] = useState('');
    const populateItemData = async () => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        setIdValue(params.get('id'));
        setOrganisationTypeValue(params.get('organisationType'));
        setNameValue(params.get('name'));
        if (searchParams.has('id')) {
            searchParams.delete('id');
            setSearchParams(searchParams);
        }
        if (searchParams.has('organisationType')) {
            searchParams.delete('organisationType');
            setSearchParams(searchParams);
        }
        if (searchParams.has('name')) {
            searchParams.delete('name');
            setSearchParams(searchParams);
        }
        const response = await axios.get(
            '/api/settings/GetExternalOrganisations/', {
            params: {}
        }
        );
        setExternalOrganisationList(response.data.content);
        setLoading(false);
        setEditPopupTitle('Add External Organisation');
        setOrganisationType(response.data.content.organisationType[0].id);
        setPriorityContaminantList(response.data.content.priorityContaminants);
        setLogoName(null);
        setLogoPhysicalFilename(null);
        setLogoPhysicalFilepath(null);
        setLogoImagePreviewUrl(null);
        setImageName(null);
        setImagePhysicalFilename(null);
        setImagePhysicalFilepath(null);
        setImagePreviewUrl(null);
        setId(0);
        setName('');
        setDescription('');
        setIsLicensedforEnterpriseDashboard(false);
        setOrganisationType(0);
        setExternalLink('');
        setCatchmentOverview('');
        setCulturalValues('');
        setSignificantSpecies('');
        setShowEditPopup(true);
        setShowCatchmentItems(false);
        setShowSupplyCompanyItems(false);
        setExternalOrganisationLinkRows([]);
        setRegionalCouncilId(0);
        setRegionalCouncils(response.data.content.regionalCouncils);
    }

    const handleExternalOrganisationLinkNameChange = idx => e => {
        const tempRows = [...externalOrganisationLinkRows];
        tempRows[idx].name = e.target.value;
        setExternalOrganisationLinkRows(tempRows);
    };
    const handleExternalOrganisationLinkChange = idx => e => {
        const tempRows = [...externalOrganisationLinkRows];
        tempRows[idx].link = e.target.value;
        setExternalOrganisationLinkRows(tempRows);
    };
    const handleExternalOrganisationLinkRowsAddRow = () => {
        const item = {
            name: "", link: "", id: 0
        };
        setExternalOrganisationLinkRows([...externalOrganisationLinkRows, item]);
    };
    const handleExternalOrganisationLinkRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...externalOrganisationLinkRows]
        tempRows.splice(idx, 1)
        setExternalOrganisationLinkRows(tempRows);
    }

    useEffect(() => {
        populateItemData();
    }, [])

    const handleChangeName = async (event) => {
        setName(event.target.value);
    }

    const handleChangeOrganisationType = async (event) => {
        setOrganisationType(parseInt(event.target.value));
        if (event.target.selectedOptions[0].text == 'Catchment') {
            setShowCatchmentItems(true);
        }
        else {
            setPriorityContaminantListSelectedValues([]);
            setCatchmentOverview('');
            setCulturalValues('');
            setSignificantSpecies('');
            setShowCatchmentItems(false);
            setUploadDocumentName(null);
            setUploadDocumentPhysicalFilename(null);
            setUploadDocumentPhysicalFilepath(null);
            setDocumentDownloadUrl(null)
        }
        if (event.target.selectedOptions[0].text == 'Supply Company') {
            setSupplyType(externalOrganisationList.supplyType[0].id);
            setShowSupplyCompanyItems(true);
        }
        else {
            setSupplyType(0);
            setShowSupplyCompanyItems(false);
        }
    }

    const handleChangeSupplyType = async (event) => {
        setSupplyType(parseInt(event.target.value));
    }
    const handleChangeRegionalCouncilId = async (event) => {
        setRegionalCouncilId(parseInt(event.target.value));
    }

    const handleChangeDescription = async (event) => {
        setDescription(event.target.value);
    }

    const handleIsLicensedforEnterpriseDashboardChange = async (event) => {
        setIsLicensedforEnterpriseDashboard(event.target.checked);
    }

    const handleChangeCatchmentOverview = async (event) => {
        setCatchmentOverview(event.target.value);
    }

    const handleChangeCulturalValues = async (event) => {
        setCulturalValues(event.target.value);
    }

    const handleChangeSignificantSpecies = async (event) => {
        setSignificantSpecies(event.target.value);
    }

    const handleChangeExternalLink = async (event) => {
        setExternalLink(event.target.value);
    }

    const closeExternalOrganisationPopup = async () => {
        window.location = '/externalorganisation?organisationType=' + organisationTypeValue + '&name=' + nameValue;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        let tempExternalOrganisationLinkRows = [...externalOrganisationLinkRows];
        let form = {
            Id: id,
            Name: name,
            OrganisationType: organisationType,
            Description: description,
            LogoName: logoName,
            LogoPhysicalName: logoPhysicalFilename,
            LogoPath: logoPhysicalFilepath,
            ImageName: imageName,
            ImagePhysicalName: imagePhysicalFilename,
            ImagePath: imagePhysicalFilepath,
            ExternalLink: externalLink,
            CatchmentOverview: catchmentOverview,
            SignificantSpecies: significantSpecies,
            CulturalValues: culturalValues,
            PriorityContaminants: priorityContaminantSelectedValues.toString(),
            SupplyType: supplyType,
            UserId: userId,
            CatchmentDocumentName: uploadDocumentName, CatchmentDocumentPhysicalName: uploadDocumentPhysicalFilename, CatchmentDocumentPath: uploadDocumentPhysicalFilepath,
            IsLicensedforEnterpriseDashboard: isLicensedforEnterpriseDashboard,
            ExternalOrganisationLinks: [], RegionalCouncilId: regionalCouncilId
        }
        for (var i = 0; i < tempExternalOrganisationLinkRows.length; i++) {
            var obj = {};
            obj.Id = tempExternalOrganisationLinkRows[i].id;
            obj.Link = tempExternalOrganisationLinkRows[i].link;
            obj.Name = tempExternalOrganisationLinkRows[i].name;
            form.ExternalOrganisationLinks.push(obj);
        }
        if (!Validate(form)) {
            const response = await axios.post(
                '/api/settings/SaveExternalOrganisations/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status) {
                    window.open("/externalorganisation", "_self");
                }
                else if (response.data.message == 'External Organisation already exists in the system') {
                    toast.error("External Organisation already exists in the system!");
                }
            }
        }
    }

    const handleLogoChange = async (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Type: "ExternalOrganisation",
                    Base64Image: result
                }
                const response = axios.post(
                    '/api/upload/UploadImage/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }).then(res => {
                        if (res.data != null) {
                            if (res.data.status) {
                                setLogoImagePreviewUrl(res.data.content.RelativeFilepath);
                                setLogoPhysicalFilename(res.data.content.PhysicalFilename);
                            }
                        }
                    });
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            setLogoName(file.name);
            setLogoFile(file);
            setLogoImagePreviewUrl(reader.result);
        }

        reader.readAsDataURL(file)
    }

    const handleImageChange = async (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Type: "ExternalOrganisation",
                    Base64Image: result
                }
                const response = axios.post(
                    '/api/upload/UploadImage/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }).then(res => {
                        if (res.data != null) {
                            if (res.data.status) {
                                setImagePreviewUrl(res.data.content.RelativeFilepath);
                                setImagePhysicalFilename(res.data.content.PhysicalFilename);
                                setImagePhysicalFilepath(res.data.content.PhysicalFilepath);
                            }
                        }
                    });
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            setImageName(file.name);
            setImageFile(file);
            setImagePreviewUrl(reader.result);
        }

        reader.readAsDataURL(file)
    }

    const getBase64 = async (file) => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    const handleChange = (e) => {
        setPriorityContaminantSelectedValues('');
        var priorityContaminantSelectedValues = '';
        setPriorityContaminantListSelectedValues(e);
        e.forEach(function (element) {
            if (priorityContaminantSelectedValues == '') {
                priorityContaminantSelectedValues = element.value;
            }
            else {
                priorityContaminantSelectedValues = priorityContaminantSelectedValues + ',' + element.value;
            }
        });
        setPriorityContaminantSelectedValues(priorityContaminantSelectedValues);
    }

    const handleBtnLogoUploadClick = async (e) => {
        e.preventDefault();
        inputLogoFile.click();
        return false;
    }

    const handleBtnImageUploadClick = async (e) => {
        e.preventDefault();
        inputImageFile.click();
        return false;
    }

    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }
    const handleBtnDocumentUploadClick = async (e) => {
        e.preventDefault();
        inputDocumentFile.click();
        return false;
    }
    const handleDocumentChange = async (e) => {
        e.preventDefault();
        setFormDocumentErrors({});
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if (file.type != 'application/pdf') {
            errors.DocumentName = "Only Pdf files can upload!";
        }
        setFormDocumentErrors(errors);
        if (Object.keys(errors).length == 0) {
            const formData = new FormData();
            formData.append("Type", "Catchment");
            formData.append("FileName", e.target.files[0].name);
            formData.append("File", e.target.files[0]);
            const response = await axios.post(
                '/api/uploaddocument/UploadDocument/', formData,
                {
                    headers: { "Content-type": "multipart/form-data", "Type": "Catchment", "userId": userId, "FileName": e.target.files[0].name },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status) {
                    setUploadDocumentName(response.data.content.DocumentName);
                    setUploadDocumentPhysicalFilename(response.data.content.DocumentPhysicalName);
                    setUploadDocumentPhysicalFilepath(response.data.content.DocumentPath);
                    setDocumentDownloadUrl(response.data.content.RelativeFilepath)
                }
            }
        }
        else {
            setUploadDocumentPhysicalFilename('');
            setUploadDocumentPhysicalFilepath('');
        }
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header d-flex justify-content-between align-items-center">
                    Add Organisation
                </h2>
                <CardBody>
                    <div >
                        <Form onSubmit={handleSubmit}>
                            <Row xs="3">
                                <Col sm="6">
                                    <FormGroup>
                                        <Label className="label" for="name">Name</Label>
                                        <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                                    </FormGroup>
                                </Col>
                                <Col sm="3">
                                    <FormGroup>
                                        <Label className="label" for="organisationType">Type Of Organisation</Label>
                                        {externalOrganisationList.organisationType == undefined && <p><em>Loading...</em></p>}
                                        {externalOrganisationList.organisationType != undefined && externalOrganisationList.organisationType != null &&
                                            <Input className="validate" type="select" value={organisationType} onChange={e => handleChangeOrganisationType(e)} name="OrganisationType" id="OrganisationType">
                                                {externalOrganisationList.organisationType.map(items =>
                                                    <option key={uuid()}  value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm="3">
                                    <Label className="label">Licensed for Enterprise Dashboard</Label> <br/>
                                    <Input className="form-check-input" type="checkbox" onChange={handleIsLicensedforEnterpriseDashboardChange} name="IsLicensedforEnterpriseDashboard" id="IsLicensedforEnterpriseDashboard" />
                                   
                                </Col>
                            </Row>
                            <Row xs="2">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="description">Description</Label>
                                        <Input type="textarea" onChange={handleChangeDescription} value={description} name="description" id="description" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="externallink">External Link</Label>
                                        {/*<Input type="textarea" onChange={handleChangeExternalLink} value={externalOrganisation.externalLink} name="externallink" id="externallink" />*/}
                                        <Row>
                                            <Col>
                                                <button onClick={handleExternalOrganisationLinkRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                                    <FaPlus/>
                                                </button>
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row style={{ overflow: "auto", height: "150px" }}>
                                            <Col>
                                                <Table className="table table-bordered table-hover" bordered style={{ tableLayout: 'fixed', width: '100%' }}>
                                                    <thead>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '45%', textAlign: 'center' }}> Name </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '45%', textAlign: 'center' }}> Link </th>
                                                        <th />
                                                    </thead>
                                                    <tbody>
                                                        {externalOrganisationLinkRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{externalOrganisationLinkRows[idx].id}</td>
                                                                <td style={{ width: "45%" }}>
                                                                    <input type="text" name="name" value={externalOrganisationLinkRows[idx].name} onChange={handleExternalOrganisationLinkNameChange(idx)} className="form-control" />
                                                                </td>
                                                                <td style={{ width: "45%" }}>
                                                                    <input type="text" name="link" value={externalOrganisationLinkRows[idx].link} onChange={handleExternalOrganisationLinkChange(idx)} className="form-control" />
                                                                </td>
                                                                <td style={{ width: "5%" }}>
                                                                    <button style={{ float: "right" }} onClick={handleExternalOrganisationLinkRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger button-delete">
                                                                        <FaTrash />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {
                                showSupplyCompanyItems &&
                                <div>
                                    <Row xs="2">
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="supplyType">Supply Type</Label>
                                                {externalOrganisationList.supplyType == undefined && <p><em>Loading...</em></p>}
                                                {externalOrganisationList.supplyType != undefined && externalOrganisationList.supplyType != null &&
                                                    <Input type="select" value={supplyType} onChange={e => handleChangeSupplyType(e)} name="supplyType" id="supplyType">
                                                        {externalOrganisationList.supplyType.map(items =>
                                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                                        )}
                                                    </Input>
                                                }
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {
                                showCatchmentItems &&
                                <div>
                                    <Row xs="2" style={{ display: 'none' }}>
                                        <Col style={{ display: 'none' }}>
                                            <FormGroup>
                                                <Label className="label" for="catchmentoverview">Catchment Overview</Label>
                                                <Input type="textarea" onChange={handleChangeCatchmentOverview} value={catchmentOverview} name="catchmentoverview" id="catchmentoverview" />
                                            </FormGroup>
                                        </Col>
                                        <Col style={{ display: 'none' }}>
                                            <FormGroup>
                                                <Label className="label" for="culturalvalues">Cultural Values</Label>
                                                <Input type="textarea" onChange={handleChangeCulturalValues} value={culturalValues} name="culturalvalues" id="culturalvalues" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row xs="2">
                                        <Col style={{ display: 'none' }}>
                                            <FormGroup>
                                                <Label className="label" for="significantspecies">Significant Species</Label>
                                                <Input type="textarea" onChange={handleChangeSignificantSpecies} value={significantSpecies} name="significantspecies" id="significantspecies" />
                                            </FormGroup>
                                            </Col>
                                        <Col style={{ display:"none" }}>
                                            <FormGroup>
                                                <Label className="label" for="significantspecies">Priority Contaminants</Label>
                                                <Select className="dropdown" placeholder="Select Option" value={priorityContaminantListSelectedValues} options={priorityContaminantList} onChange={handleChange} isMulti isClearable />
                                            </FormGroup>
                                        </Col>  
                                    </Row>
                                    <Row xs="2">
                                        <Col>
                                            <FormGroup>
                                                    <Label className="label" for="regionalCouncilId">Regional council association</Label>
                                                    {regionalCouncils == undefined && <p><em>Loading...</em></p>}
                                                    {regionalCouncils != undefined && regionalCouncils != null &&
                                                        <Input type="select" value={regionalCouncilId} onChange={e => handleChangeRegionalCouncilId(e)} name="regionalCouncilId" id="regionalCouncilId">
                                                        {regionalCouncils.map(items =>
                                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                                        )}
                                                    </Input>
                                                }
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            <Row xs="2">
                                {1 == 2 && <Col>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Label className="label" for="externallink">Logo</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {logoImagePreviewUrl && <img className="settings-image-style" src={logoImagePreviewUrl} onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, logoName, logoImagePreviewUrl)} />}
                                                <br />
                                                {logoImagePreviewUrl ?
                                                    <Button color="warning" size="sm" onClick={handleBtnLogoUploadClick} ><FaUpload /> Modifiy Logo</Button> :
                                                    <Button color="success" size="sm" onClick={handleBtnLogoUploadClick} ><FaUpload /> Upload Logo</Button>}
                                                <input style={{ display: 'none' }}
                                                    ref={input => {
                                                        inputLogoFile = input;
                                                    }}
                                                    className="fileInput" id="fileUpload" type="file" onChange={(e) => handleLogoChange(e)} />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>}
                                <Col>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Label className="label" for="externallink">Image</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {imagePreviewUrl && <img className="settings-image-style" src={imagePreviewUrl} onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, imageName, imagePreviewUrl)} />}
                                                <br />
                                                {imagePreviewUrl ?
                                                    <Button color="warning" size="sm" onClick={handleBtnImageUploadClick} ><FaUpload /> Modifiy Image</Button> :
                                                    <Button color="success" size="sm" onClick={handleBtnImageUploadClick} ><FaUpload /> Upload Image</Button>}
                                                <input style={{ display: 'none' }}
                                                    ref={input => {
                                                        inputImageFile = input;
                                                    }}
                                                    className="fileInput" id="fileUpload" type="file" onChange={handleImageChange} />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                                {showCatchmentItems && <Col>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Label className="label" for="externallink">Catchment Document</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {documentDownloadUrl && <a href={documentDownloadUrl} target='_blank'>
                                                    <img src="/images/PDF_icon.png" className="PDF_icon settings-image-style" ></img> <span >{uploadDocumentName}</span>
                                                    <br />

                                                </a>}
                                                <br />
                                                {documentDownloadUrl ?
                                                    <Button color="warning" size="sm" onClick={handleBtnDocumentUploadClick} ><FaUpload /> Modifiy Document</Button> :
                                                    <Button color="success" size="sm" onClick={handleBtnDocumentUploadClick} ><FaUpload /> Upload Document</Button>}
                                                <input style={{ display: 'none' }}
                                                    ref={input => {
                                                        inputDocumentFile = input;
                                                    }}
                                                    className="fileInput" id="fileUpload" type="file" onChange={handleDocumentChange} />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    {formDocumentErrors.DocumentName != undefined &&
                                        <p className="errorMessage">{formDocumentErrors.DocumentName}</p>
                                    }
                                </Col>}
                            </Row>
                            <Row>
                                <Col>
                                    <input type="submit" value="Save" size="sm" className="btn btn-save" />
                                    <Button className="btn-back-list" color="warning" onClick={closeExternalOrganisationPopup}><FaChevronLeft /> Back To List</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </CardBody>
            </Card>

            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}
export default CreateExternalOrganisation;